import styled from 'styled-components';
import Btn30 from 'dc/Btn30';
import Act64 from 'dc/Act64';
import { Typ32, Typ20 } from 'dc/Typ';
import Load02 from 'dc/Load02';

export const ActivityCard = styled.div`
  display: flex;
  cursor: default;
  flex-direction: row;
  width: 100%;
  padding-right: 14px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.1);
`;

export const Highlight = styled.div`
  border-radius: 4px 0 0 4px;
  cursor: default;
  min-width: 6px;
  background-color: ${props => props.color || '#fff'};
`;

export const CardActionArea = styled.button`
  border: none;
  cursor: default;
  background: #fff;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  padding-bottom: 16px;
`;

export const ActivityIcon = styled(Act64)`
  margin-left: 10px;
  margin-top: 16px;
  cursor: default;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: default;
  margin-top: 16px;
  margin-left: 16px;
  width: 100%;
  text-align: left;
  word-break: break-word;
`;

export const Title = styled(Typ32)`
  z-index: 1;
  display: block;
  margin-bottom: 6px;
  cursor: default;
  width: calc(100% + 60px);
  font-weight: 400;
  color: #5e6372;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    width: 100%;
  }
`;

export const Text = styled(Typ20)`
  text-decoration: underline;
  color: #007079;
  cursor: default;
  margin-top: 14px;
`;

export const CardActions = styled.div`
  display: flex;
  flex-direction: column-reverse;
  cursor: default;
  padding: 0 0 16px 12px;
`;

export const LogLoader = styled(Load02)`
  margin: 3px;
`;

export const LogButton = styled(Btn30)`
  flex-shrink: 0;
  cursor: default;
  &:hover i {
    color: #eceff1;
  }
`;
